import { createContext } from "react";

export type UserLanguageContextType = {
    userLanguage: (language: string) => void;
}

export const UserLanguageContext = createContext<UserLanguageContextType | undefined>(undefined);
